import fetch from '@agilytics/fetch';

export const getCurrentUser = async (accessToken, cloudId) => {
  if (!accessToken || !cloudId) {
    return {};
  }
  try {
    return await fetch(`https://api.atlassian.com/ex/jira/${cloudId}/rest/api/3/myself`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  } catch (e) {
    console.error(e);
    return {};
  }
};

export const getCloudIds = async accessToken => {
  if (!accessToken) {
    return [];
  }
  return await fetch('https://api.atlassian.com/oauth/token/accessible-resources', {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

export const getProjects = async (accessToken, cloudId, query) => {
  if (!accessToken || !cloudId) {
    return [];
  }
  const params = new URLSearchParams();
  if (query) {
    params.set('query', query);
  }
  const API_URL = `https://api.atlassian.com/ex/jira/${cloudId}/rest/api/3/project/search?${params}`;
  const res = await fetch(API_URL, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  return res.values;
};

export const getIssues = async (accessToken, cloudId, projectId, startAt = 0) => {
  if (!accessToken || !cloudId || !projectId) {
    return [];
  }

  const jql = `project = '${projectId}' and statusCategory = 'done' order by statusCategoryChangedDate desc`;

  const params = new URLSearchParams();
  params.set('maxResults', 100);
  params.set('startAt', startAt);
  params.set('jql', jql);

  const API_URL = `https://api.atlassian.com/ex/jira/${cloudId}/rest/api/3/search?${params}`;
  const res = await fetch(API_URL, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return res.issues;
};

export const getStatuses = async (accessToken, cloudId, projectId) => {
  const API_URL = `https://api.atlassian.com/ex/jira/${cloudId}/rest/api/3/project/${projectId}/statuses`;
  const res = await fetch(API_URL, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  return res;
};
